import React from "react";
import { useTheme } from "@mui/material/styles";
import { MenuProps as MuiMenuProps } from "@mui/material"
import {
  CustomMenu,
} from "./Menu.styles";
import { VariantStyles } from "./Menu.variants";
export interface CustomVariantMenuProps extends Omit<MuiMenuProps, "variant">  {
  children: React.ReactNode;
  variant?: "default" | "noPadding" | "withShadow" | "withShadowWithoutPadding" | "fitContent";
}

export const Menu = ({
  children,
  variant = "default",
  ...rest
}: CustomVariantMenuProps) => {
  const theme = useTheme();

  const variantStylesFn = VariantStyles(theme);

  return (
    <CustomMenu data-cy="custom-menu"
      sx={{
        ...variantStylesFn[variant],
      }}
      {...rest}
    >
      {children}
    </CustomMenu>
  );
};

export interface MenuProps extends React.ComponentProps<typeof Menu> {
  as?: React.ElementType;
}

Menu.displayName = "Menu";